import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import {
  ANNUITY_TAX_STATUS_OPTIONS,
  ANNUITY_TYPE_OPTIONS,
  AnnuityType as AnnuityTypes,
  applyAnnuityTaxStatusToFormValues,
  getAnnuityTaxStatus,
} from '../../AccountForm.meta';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Radio } from '../../../../../../../../CommonComponents/OPL/Radio/Radio';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';

export const SelectAnnuityType = () => {
  const { control, watch, setValue } = useFormContext();
  const { setAlert, usageContext } = useAccountFormContext();

  const [positions, annuityType, annuityIsQualified, annuityIsRoth] = watch([
    'bankAccount.Positions',
    'bankAccount.AnnuityType',
    'bankAccount.AnnuityIsQualified',
    'bankAccount.AnnuityIsRoth',
  ]);

  useEffectOnce(() => {
    if (
      usageContext === AccountModalUsageContext.AnnuityPurchaseWhatIf &&
      annuityType === undefined
    ) {
      setValue('bankAccount.AnnuityType', AnnuityTypes.Fixed);
    }
  });

  return (
    <>
      <Controller
        control={control}
        name="bankAccount.AnnuityType"
        render={({ field: { value, onChange, ...field } }) => {
          return (
            <Select
              {...field}
              options={ANNUITY_TYPE_OPTIONS}
              value={ANNUITY_TYPE_OPTIONS.find(option => option.value === value)}
              label="Annuity Type"
              onChange={opt => {
                onChange(opt?.value);

                if (opt?.value === AnnuityTypes.Fixed && positions.length > 0) {
                  setAlert({
                    type: 'info',
                    message:
                      'Changing to a fixed annuity will result in the removal of your holdings.',
                  });
                }
              }}
            />
          );
        }}
      />

      <Box>
        <Text as="label" variant="formLabel" color="neutral.600">
          Tax Status
        </Text>

        <Box display="flex" mb="8">
          <Controller
            control={control}
            name="bankAccount.AnnuityTaxStatus"
            render={({ field: { value, name, onChange, disabled } }) => {
              const selectedTaxStatus =
                value ??
                getAnnuityTaxStatus({
                  AnnuityIsQualified: annuityIsQualified,
                  AnnuityIsRoth: annuityIsRoth,
                });

              return (
                <>
                  {ANNUITY_TAX_STATUS_OPTIONS.map(option => (
                    <Radio
                      key={option.value}
                      name={name}
                      checked={selectedTaxStatus === option.value}
                      disabled={disabled}
                      onChange={() => {
                        const {
                          AnnuityIsQualified,
                          AnnuityIsRoth,
                          AnnuityTaxStatus,
                        } = applyAnnuityTaxStatusToFormValues(option.value);

                        setValue('bankAccount.AnnuityIsQualified', AnnuityIsQualified);
                        setValue('bankAccount.AnnuityIsRoth', AnnuityIsRoth);
                        onChange(AnnuityTaxStatus);
                      }}
                      mr="8"
                    >
                      {option.label}
                    </Radio>
                  ))}
                </>
              );
            }}
          />
        </Box>
      </Box>
    </>
  );
};
